<template>
    <div>
        <div class="eventInformation">
            <v-container class='pt-0'>
                <v-layout row wrap>
                    <v-flex sm7 class='information'>
                        <h3>Event List</h3>
                        <ul v-if="events">
                            <li v-for="event in events" :key="event">
                                <a v-bind:href="event.slug" target="_blank">
                                    {{ event.name }}
                                </a>
                            </li>
                        </ul>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      events: {}
    };
  },
  computed: {
    content() {
      return event.content ? event.content : false;
    },
    id() {
      return this.extract('event.id');
    },
    hasAside() {
      var aside = this.extract('event.content.aside.custom');
      return aside !== null;
    },
    defaultAside() {
      return !this.extract('event.content.aside.custom') || !this.extract('event.content.aside.html');
    },
    registrationIsSingle() {
      return this.maxRegistrants === 1;
    },
    registrantSlots() {
      let slots = [];
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + " attendee", value: i });
        } else {
          slots.push({ text: i + " attendees", value: i });
        }
      }
      return slots;
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    loaded() {
      return !this.loading;
    },
    showSubmitPrompt() {
      return !this.submittedSuccessfully && this.registrants > 0;
    }
  },
  methods: {
    extract: function(valueString) {
      var keys = valueString && valueString.length ? valueString.split('.') : [];
      var numKeys = keys.length;
      var object = null;

      if (numKeys > 0 && this.hasOwnProperty(keys[0])) {
        object = this[keys[0]];
      } else {
        return null;
      }

      for (var i = 1; i < numKeys; i++) {
        var key = keys[i];
        if (object.hasOwnProperty(key)) {
          object = object[key];
        } else {
          return null;
        }
      }

      return object;
    },
    initializeSlots() {
      let backup = this.registrant;
      this.registrant = [];
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person];
        } else {
          this.registrant[person] = {
            name: '',
            email: null,
            role: null
          };
        }
      }
    },
    submitRegistration() {
      if (this.$refs.regForm.validate()) {
        this.submitted = true;
        let data = {
          school: this.schoolName,
          district: this.districtName,
          state: this.stateName,
          team_total: this.registrants,
          registration_event_id: this.extract('event.id'),
          registration_team_member: this.registrant,
          single_registration: this.registrationIsSingle
        };

        if (this.registrationIsSingle) {

        }

        this.$http.post('registrations', data).then(
          response => {
            if (this.registrationIsSingle) {
              this.$router.push({ path: "/event/terms/" + response.body.data.registration_team_member[0].uuid });
              this.$store.commit("updateMessage", {
                message: "Please review the terms and conditions to complete registration.",
                snackbar: true
              });
            } else {
              this.submittedSuccessfully = true;
            }
          },
          response => {
            this.submitted = false;
            this.$store.commit("updateMessage", {
              message: "There was a problem saving your registration. Please try again or contact support.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message: "Required fields are missing. Please review the form.",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    this.$http.get('events/list').then((response) => {
      this.events = response.data.data;
      // eslint-disable-next-line handle-callback-err
    }, error => {
      this.$router.push('/404')
    });
  }
}
</script>
